import React, { memo } from 'react'
import Grid from 'transfix-ui/core/Grid'
import Skeleton from 'transfix-ui/core/Skeleton'
import { makeStyles } from 'transfix-ui/core/styles'

const useDedicatedLanesBidFormSkeletonStyles = makeStyles(theme => ({
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'center',
  },
}))

export interface IDedicatedLanesBidFormSkeletonProps {}

const FormFieldSkeleton = memo(() => {
  return (
    <div>
      <Skeleton variant='text' width={75} />
      <Skeleton variant='rectangular' height={42} />
    </div>
  )
})

const DedicatedLanesBidFormSkeleton = memo<IDedicatedLanesBidFormSkeletonProps>(() => {
  const classes = useDedicatedLanesBidFormSkeletonStyles()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Skeleton variant='rectangular' height={27} width={100} />
      </Grid>
      <Grid item xs={12}>
        <div className={classes.flex}>
          <Skeleton variant='rectangular' height={46} width={50} />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rectangular' height={46} />
      </Grid>
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <div className={classes.checkbox}>
          <Skeleton variant='rectangular' height={16} width={16} />
          <Skeleton variant='text' width={150} />
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <FormFieldSkeleton />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rectangular' height={37} />
      </Grid>
      <Grid item xs={12}>
        <div className={classes.flex}>
          <Skeleton variant='rectangular' height={19} width={150} />
        </div>
      </Grid>
    </Grid>
  )
})

export default DedicatedLanesBidFormSkeleton
